import * as m from "mithril";
import { getIntlStringValue } from "../../helpers/StringHelpers";
import { MessageProvider } from "../../context/AppMessages";
import { InternationalStringDTO } from "../../apiclient/ApiDtos";
interface Attrs {
  messageProvider: MessageProvider,
  terms: InternationalStringDTO,
  onCloseModal: () => void
}

export function PaymentTermsModal(): m.Component<Attrs> {
    return {
        oninit: () => {
          document.body.classList.add('body-no-scroll');
        },
        onremove: () => {
          document.body.classList.remove('body-no-scroll');
        },
      
        view(vnode) {
            return m("div", {
              class: "modal-backdrop",
              onclick: (event) => {
                  event.preventDefault();
                  vnode.attrs.onCloseModal();
              }
          },
              m("dialog.terms-modal border-0 bg-white w-100 shadow-sm py-4", {
                  id: "dialog",
                  open: true,
                  onclick: (event) => {
                      event.stopPropagation();
                  }
              },[
                m("div",
                  m("div.fw-bold font-weight-bold", vnode.attrs.messageProvider.get("terms"))
                ),
                m("div.custom-hr"),
                m("div.paragraph-line-height", 
                  m.trust(getIntlStringValue(
                    vnode.attrs.terms, 
                    vnode.attrs.messageProvider.getCurrentLang()
                  ))
                ),
                m("div.custom-hr"),
                m("div.text-end text-right mt-4",
                  m("button.btn btn-outline-primary", {
                    onclick: (event) => {
                      event.preventDefault();
                      vnode.attrs.onCloseModal();
                  }
                  },"OK")
                )
              ]
            )
          )
        }
    }
}

/* 
import * as m from "mithril";
import '../../components/ModalDialog.css';

export default function PaymentTermsModalDialog(): m.Component<{
    title? : string,    
    message? : string,
    shouldOpen: boolean,
    onClosed: () => void
}> {
    let dialogElem:HTMLDialogElement|null = null;
        
    return {        
        oncreate(vnode) {
            dialogElem = vnode.dom as HTMLDialogElement;
        },

        onbeforeupdate(vnode) {
            if(dialogElem) {
                if(dialogElem.open) {
                    if(vnode.attrs.shouldOpen == false) {
                        dialogElem.close();
                    } 
                } else {
                    if(vnode.attrs.shouldOpen) {
                        dialogElem.showModal();
                    }
                }
            }
        },

        onupdate(vnode) {
            console.log(vnode.attrs);
        },

        view(vnode) {            
            return m("dialog", {
                class: "dialog-modal"
            },                
                [
                    m("div.card-header",{class:"pb-2 bg-white border-0"}, [     
                      

                        (vnode.attrs.title != null)? 
                        m("span.lead", {class:"font-weight-bold mb-3"}, vnode.attrs.title) : null,

                    ]),
                    m("div.card-body.pt-0", [       
                        (vnode.attrs.message != null)?
                        m("div", {class:"mb-1"}, 
                            m.trust(vnode.attrs.message)
                        ): null,

                      vnode.children,
                      m("div.custom-hr"),
                      m("div.text-end text-right mt-4",
                        m("button.btn btn-outline-primary", {
                          onclick: (event) => {
                            event.preventDefault();
                            vnode.attrs.onClosed();
                          }
                        }, "OK")
                      )
                    ])
                    
                ]
            )
        }
    };
}
 */